module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "team-member-circle-wrapper",
    class: {
      'active': _vm.isActive
    },
    style: ({
      'width': _vm.width || '45px',
      'height': _vm.height || '45px'
    })
  }, [_c('span', {
    staticClass: "activity-indicator"
  }), _vm._v(" "), _c('span', {
    staticClass: "team-member-initials",
    style: ({
      'background-color': _vm.subject.profile_color,
      'width': _vm.width || '45px',
      'height': _vm.height || '45px'
    })
  }, [_vm._v(_vm._s(_vm.initials))]), _vm._v(" "), (_vm.subject.photo_url) ? _c('img', {
    staticClass: "team-member-image",
    style: ({
      'width': _vm.width || '45px',
      'height': _vm.height || '45px'
    }),
    attrs: {
      "src": _vm.subject.photo_url
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a045152","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/partials/team-member-avatar.vue
// module id = 533
// module chunks = 0